import {
  Component, OnInit,
  Directive,
  ElementRef,
  Input,
  ViewChild
} from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from '../../services/data.service';
import { DatePipe } from '@angular/common';

export interface ReverseModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-reversecharge-edit',
  templateUrl: './reversecharge-edit.component.html',
  styleUrls: ['./reversecharge-edit.component.css']
})

export class ReverseChargeEditComponent extends DialogComponent<ReverseModel, boolean> implements ReverseModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  dt = new ReverseCharge_Edit();
  result: any = { result: false, RtnItem: {} };

  @ViewChild("DForeignCurrencyAmt") DForeignCurrencyAmt: ElementRef;
  @ViewChild("DAmount") DAmount: ElementRef;
  @ViewChild("DImportDuty") DImportDuty: ElementRef;
  @ViewChild("DCess") DCess: ElementRef;
  @ViewChild("DOtherCharges") DOtherCharges: ElementRef;
  @ViewChild("DTotal") DTotal: ElementRef;

  constructor(dialogService: DialogService, private ds: DataService, public datepipe: DatePipe) { super(dialogService); }

  ngOnInit() {
    this.clear()
    this.result.result = false;
    for (let i of this.data) {
      if (i.Name == 'ForeignCurrencyAmt') {
        this.dt.ForeignCurrencyAmt = i.Value;
      }
      else if (i.Name == 'Amount') {
        this.dt.Amount = i.Value;
      }
      else if (i.Name == 'ImportDuty') {
        this.dt.ImportDuty = i.Value;
      }
      else if (i.Name == 'Cess') {
        this.dt.Cess = i.Value;
      }
      else if (i.Name == 'OtherCharges') {
        this.dt.OtherCharges = i.Value;
      }
      else if (i.Name == 'Total') {
        this.dt.Total = i.Value;
      }
      else if (i.Name == 'ConvertionRate') {
        this.dt.ConvertionRate = i.Value;
      }
    }
  }
  ok() {
    if (this.dt.ForeignCurrencyAmt == 0) {
      alert("FCY Amount is Zero");
    }

    else {
      this.result.RtnItem['ForeignCurrencyAmt'] = this.dt.ForeignCurrencyAmt;
      this.result.RtnItem['Amount'] = this.dt.Amount;
      this.result.RtnItem['ImportDuty'] = this.dt.ImportDuty;
      this.result.RtnItem['Cess'] = this.dt.Cess;
      this.result.RtnItem['OtherCharges'] = this.dt.OtherCharges;
      this.result.RtnItem['Total'] = this.dt.Total;
      this.result.result = true;
      this.close()
    }
  }

  delete() {
    this.result.result = true;
    this.result.delete = true;
    this.close();
  }

  clear() {
    this.dt = new ReverseCharge_Edit();
  }

  selectAll(e) {
    e.target.select()
  }

  ForeignCurrencyAmtLeave() {
    this.DAmountCaluctlate();

  }

  ForeignCurrencyAmtKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.ForeignCurrencyAmtLeave();
    }
  }

  DAmountCaluctlate() {
    this.dt.Amount = Number(this.dt.ConvertionRate) * Number(this.dt.ForeignCurrencyAmt);
    this.DTotalCalculate();
    this.DImportDuty.nativeElement.focus();
  }

  DAmountLeave() {
    this.DImportDuty.nativeElement.focus();
  }

  DAmountKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.DAmountLeave();
    }
  }

  DImportDutyKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.DImportDutyLeave();
    }
  }

  DImportDutyLeave() {
    this.DTotalCalculate();
    this.DCess.nativeElement.focus();
  }

  DTotalCalculate() {
    this.dt.Total = Number(this.dt.Amount) + Number(this.dt.ImportDuty) + Number(this.dt.Cess) + Number(this.dt.OtherCharges);
  }

  DCessLeave() {
    this.DTotalCalculate();
    this.DOtherCharges.nativeElement.focus();
  }

  DCessKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.DCessLeave();
    }
  }

  DOtherChargesKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.DOtherChargesLeave();
    }
  }
  DOtherChargesLeave() {
    this.DTotalCalculate();
    this.DTotal.nativeElement.focus();
  }

  DTotalLeave() {

  }

  DTotalKeydown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.DTotalLeave();
    }
  }

}

class ReverseCharge_Edit {
  ForeignCurrencyAmt: number = 0;
  Amount: number = 0;
  ImportDuty: number = 0;
  Cess: number = 0;
  OtherCharges: number = 0;
  Total: number = 0;
  ConvertionRate: number = 0;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/reversecharge-edit/reversecharge-edit.component.ts